import React from 'react';
import { useTranslation } from 'react-i18next';
import './DietTypePickerModal.css';

/**
 * DietTypePickerModal — lets the user choose between a weekly or alternatives
 * diet structure before opening an editor. Reusable in any context via `title`.
 *
 * @param {Object}   props
 * @param {string}   props.title        - Header text (caller-supplied for context)
 * @param {Function} props.onWeekly     - Called when the Weekly option is selected
 * @param {Function} props.onAlternatives - Called when the Alternatives option is selected
 * @param {Function} props.onClose      - Called when the modal is dismissed
 */
const DietTypePickerModal = ({ title, onWeekly, onAlternatives, onClose }) => {
    const { t } = useTranslation();

    return (
        <div className="dtpm-overlay" onClick={onClose}>
            <div className="dtpm-modal" onClick={(e) => e.stopPropagation()}>

                {/* ── Header ── */}
                <div className="dtpm-header">
                    <h2 className="dtpm-title">{title}</h2>
                    <button className="dtpm-close-btn" onClick={onClose} aria-label={t('Cancel')}>
                        <span className="material-symbols-outlined">close</span>
                    </button>
                </div>

                {/* ── Options ── */}
                <div className="dtpm-body">
                    <button className="dtpm-option" onClick={onWeekly}>
                        <span className="dtpm-option-icon material-symbols-outlined">calendar_month</span>
                        <span className="dtpm-option-text">
                            <span className="dtpm-option-title">{t('weekly')}</span>
                            <span className="dtpm-option-desc">{t('weekly-explaination-info')}</span>
                        </span>
                        <span className="dtpm-option-chevron material-symbols-outlined">chevron_right</span>
                    </button>

                    <button className="dtpm-option" onClick={onAlternatives}>
                        <span className="dtpm-option-icon material-symbols-outlined">shuffle</span>
                        <span className="dtpm-option-text">
                            <span className="dtpm-option-title">{t('alternatives')}</span>
                            <span className="dtpm-option-desc">{t('alternatives-explaination-info')}</span>
                        </span>
                        <span className="dtpm-option-chevron material-symbols-outlined">chevron_right</span>
                    </button>
                </div>

                {/* ── Footer ── */}
                <div className="dtpm-footer">
                    <button className="dtpm-cancel-btn" onClick={onClose}>{t('Cancel')}</button>
                </div>

            </div>
        </div>
    );
};

export default DietTypePickerModal;
